class NSSAccordionGroup extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.els = {
      items: this.querySelectorAll(`.nss-accordion-item`),
    };
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Accordion Group] Connected.`);

    this.addEventListener(`click`, this.handleClick.bind(this));

    // Optional: link the open item's image to an external "detail" image pane
    // (e.g. the "Three lines" section — the left image swaps with the open item).
    if (this.hasAttribute(`nss-link-image`)) this.initImageLink();
  }

  handleClick(e) {
    const item = e.target.closest(`.nss-accordion-item`);
    if (!item || !this.contains(item)) return;

    if (item.classList.contains(`nss-active`)) {
      this.closeAllItems();
    } else {
      this.closeAllItems();
      item.classList.add(`nss-active`);
      this.swapImage(item);
    }
  }

  closeAllItems() {
    this.els.items.forEach((itemEl) => {
      itemEl.classList.remove(`nss-active`);
    });
  }

  initImageLink() {
    const section = this.closest(`nss-hero`) || this.closest(`[data-section-id]`);
    // ALL linked detail panes in this section swap together — e.g. the "Three lines"
    // section has a desktop image (left of the accordion) AND a separate mobile image
    // (in the accordion column, after the headline); both must track the open item.
    this.targetImgs = section ? section.querySelectorAll(`[data-nss-detail-target] img`) : [];
    if (!this.targetImgs.length) return;

    const openItem = Array.prototype.find.call(this.els.items, (i) =>
      i.classList.contains(`nss-active`)
    );
    if (openItem) this.swapImage(openItem);
  }

  swapImage(item) {
    if (!this.targetImgs || !this.targetImgs.length) return;

    const url = item.getAttribute(`data-accordion-image`);
    if (!url) return;

    this.targetImgs.forEach((img) => {
      if (img.getAttribute(`src`) === url) return;

      img.style.transition = `opacity 0.2s ease-in-out`;
      img.style.opacity = `0`;

      window.setTimeout(() => {
        const pre = new Image();
        pre.onload = () => {
          img.removeAttribute(`srcset`);
          img.removeAttribute(`sizes`);
          img.src = url;
          img.style.opacity = `1`;
        };
        pre.onerror = () => {
          img.style.opacity = `1`;
        };
        pre.src = url;
      }, 180);
    });
  }
}

let elementName = `nss-accordion-group`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSAccordionGroup);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
